import { FallbackProps } from "react-error-boundary";
import styles from "./error-fallback.module.scss";

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <div role="alert" className={styles.container}>
      <h1 className={styles.header}>Something went wrong</h1>
      <p className={styles.info}>Please try again later</p>
    </div>
  );
};

export default ErrorFallback;
